import {
  Box,
  Button,
  Center,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Input,
  Stack,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import WrapContent from '../components/WrapContent';

const SignIn = () => {
  return (
    <Box bg="gray.50">
      <WrapContent>
        <HStack justifyContent={'space-between'}>
          <Box py="5">
            <u>
              <Link to="/signup">Signup instead?</Link>
            </u>
          </Box>
          <Box py="5">
            <u>
              <Link to="/">Go back Home</Link>
            </u>
          </Box>
        </HStack>

        <Center minH="90vh">
          <Stack spacing="5" maxW="400px" w="full">
            <Heading as="h1">LOGIN</Heading>
            <Stack spacing="5" w="full">
              <FormControl w="full">
                <FormLabel mb="-0.5" htmlFor="username">
                  Username
                </FormLabel>

                <Input size="md" type="text" placeholder="write username" />
              </FormControl>

              <FormControl w="full">
                <FormLabel mb="-0.5" htmlFor="password">
                  Password
                </FormLabel>

                <Input size="md" type="password" placeholder="password" />
              </FormControl>

              <Button rounded="lg" colorScheme={'teal'} type="submit">
                Login
              </Button>
              <Box>
                <Box>
                  <Link to="/signup">Forgot password?</Link>
                </Box>
              </Box>
            </Stack>
          </Stack>
        </Center>
      </WrapContent>
    </Box>
  );
};

export default SignIn;
